import React, { useContext } from 'react';
import { TemplateContext } from '../../layout';
import Header from '../header';
import ProductsList from '../productsList';
import Message from '../message';
import TestimonialSlider from '../testimonials';
import BenefitsList from '../benefitsList';
import OrderSummary from '../orderSummary';
import Hero from '../hero';
import WarrantyCheckbox from '../warrantyCheckbox';
import OutsideClick from '../outsideClick';
import WarrantyPopup from '../warrantyPopup';
import Form from '../forms/form';

const HalfWidthProducts = ({ base, containerClass, products, compliance }) => {
	const [templateContext] = useContext(TemplateContext);
	const showPopup = templateContext?.showPopup && templateContext?.displayPopup;

	return (
		<>
			<Header {...base?.checkout_v3_header} />
			<Hero {...base?.checkout_v3_hero} />
			<main className="main">
				<section className={containerClass}>
					<article className="productContainer">
						{!templateContext.outOfStockMode && <Message />}
						<ProductsList products={products} layoutOption="half">
							{templateContext?.config?.isWarrantySelected && (
								<div className="onlyMobile">
									<section className="warrantyContainer">
										{showPopup && (
											<OutsideClick>
												<WarrantyPopup
													data={base?.checkout_v3_warranty}
													showPopup={templateContext?.showPopup}
												/>
											</OutsideClick>
										)}
										{!templateContext.outOfStockMode && (
											<div style={{ marginTop: compliance && '8px' }}>
												<WarrantyCheckbox
													data={base?.checkout_v3_warranty}
													handleClick={() => toggleWarrantyCheckbox()}
													value={templateContext.config?.warrantyState}
												/>
											</div>
										)}
									</section>
								</div>
							)}
						</ProductsList>

						{!compliance && <TestimonialSlider data={base?.checkout_v3_testimonials} displayOnMobile={false} />}
						{templateContext?.config?.isWarrantySelected && (
							<section className="warrantyContainer onlyDesktop">
								{showPopup && (
									<OutsideClick>
										<WarrantyPopup data={base?.checkout_v3_warranty} showPopup={templateContext.showPopup} />
									</OutsideClick>
								)}
								{!templateContext.outOfStockMode && (
									<div style={{ marginTop: compliance && '20px' }}>
										<WarrantyCheckbox
											marginTop={true}
											handleClick={() => toggleWarrantyCheckbox()}
											value={templateContext.config?.warrantyState}
											data={base?.checkout_v3_warranty}
										/>
									</div>
								)}
							</section>
						)}
						<BenefitsList data={base?.checkout_v3_benefits} fullWidth="half" displayDesktop={true} />
					</article>
					<article
						className="formContainer formContainer--fullWidth"
						data-outofstock={templateContext.outOfStockMode}
					>
						<Form />
						{!templateContext.outOfStockMode && <OrderSummary />}
					</article>
				</section>
				<section className="bottomContainer">
					{!compliance && (
						<TestimonialSlider {...base?.checkout_v3_testimonials} fullWidth="half" displayOnMobile={true} />
					)}
				</section>
				<section className="bottomContainer">
					{!compliance && <TestimonialSlider data={base?.checkout_v3_testimonials} displayOnMobile={true} />}
					<div style={{ marginTop: compliance && '16px' }}>
						<BenefitsList data={base?.checkout_v3_benefits} fullWidth="full" displayTablet={true} />
					</div>
				</section>
			</main>
		</>
	);
};

export default HalfWidthProducts;
